import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IRule, ICondition } from '../../../../Models/tenant';
import { ModuleUniqueIds } from '../../../../Constants/ModuleUniqueIds';
import { Field, IStateTransition } from '../Models';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { ModuleConditionComponent } from './module.condition.component';

@Component({
    selector: "my-modules-rule",
    templateUrl: "./module.rule.component.html",
    styleUrls: ["./module.component.css"],
    imports: [MatButton, MatIcon, MatFormField, MatInput, FormsModule, MatIconButton, ModuleConditionComponent]
})
export class ModuleRuleComponent implements OnInit {
    @Input() moduleId: string;
    @Input() rule: IRule;
    @Input() transition: IStateTransition; // Needed for newRuleFunction
    @Input() stateRules: IRule[]; // Needed for newRuleFunction
    @Input() stateRulesToSave: number[];
    @Input() conditionFields: Field[];
    @Input() listItemsCache: any[];
    @Output() editRuleClicked: EventEmitter<IRule> = new EventEmitter<IRule>();

    showRule: boolean;
    
    constructor(
        public dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.showRule = this.ruleIsEditable();
    }

    ruleIsEditable(): boolean {
        return this.stateRulesToSave.indexOf(this.rule.Id) !== -1;
    }

    onEditButtonClick() {
        this.editRuleClicked.emit(this.rule);
    }

    onDeleteButtonClick() {
        this.deleteRule();
    }

    deleteRule() {
        this.transition.PreConditionRules = this.transition.PreConditionRules.filter((r) => r !== this.rule.Id);
        this.stateRulesToSave = this.stateRulesToSave.filter((r) => r !== this.rule.Id);
    }

    onAddConditionButtonClick() {
        this.addCondition();
    }

    addCondition() {
        let parentName = "";

        if (this.moduleId === ModuleUniqueIds.Events) {
            parentName = "Airsweb.Modules.EventTracking.FormFlow.Core.Entity.EventTrackingModel";
        }
        if (this.moduleId === ModuleUniqueIds.Risk) {
            parentName = "Airsweb.RiskAssessment.FormFlow.Core.Entity.RiskAssessmentModel";
        }
        if (this.moduleId === ModuleUniqueIds.Register) {
            parentName = "Airsweb.Register.FormFlow.Core.Entity.RegisterModel";
        }

        if (this.moduleId === ModuleUniqueIds.Register) {
            parentName = "Airsweb.Register.FormFlow.Core.Entity.RegisterModel";
        }

        if (this.moduleId === ModuleUniqueIds.PermitToWork) {
            parentName = "Airsweb.Modules.PermitToWork.FormFlow.Core.Entity.PermitToWorkModel";
        }

        if (this.moduleId === ModuleUniqueIds.TallyIndex) {
            parentName = "Airsweb.Modules.TallyIndex.FormFlow.Core.Entity.TallyIndexModel";
        }

        const newCondition: ICondition = {
            $type: "Airsweb.Utilities.BusinessRules.Entity.ConditionString, Airsweb.Utilities",
            Operator: null,
            Value: "",
            ValueArray: [],
            ParentName: parentName,
            MultiItemName: null,
            PropertyName: "",
            PropertyType: "String"
        }

        this.rule.Conditions.push(newCondition);
    }
}